<!--class="container-narrow"-->
<div class="h-100">
  <div class="_container_root">
    <router-outlet></router-outlet>
  </div>
</div>

<footer-cmp></footer-cmp>
